var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.93186 0.678982L5.82077 4.5679C6.05942 4.80654 6.05942 5.19346 5.82077 5.4321L1.93186 9.32102C1.69321 9.55966 1.3063 9.55966 1.06765 9.32102C0.829011 9.08237 0.829011 8.69546 1.06765 8.45681L4.47205 5.05242V4.94758L1.06765 1.54319C0.829011 1.30454 0.829011 0.917626 1.06765 0.678982C1.3063 0.440339 1.69321 0.440339 1.93186 0.678982Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.58b59563b97236d1f4d92ebcdbed7f9c.svg";
export { ForwardRef as ReactComponent };